<template>
  <div class="nutSwiper">
    <nut-swiper
      direction="horizontal"
      :loop="true"
      :canDragging="true"
      :autoPlay="3000"
      :paginationClickable="true"
      :swiperData="list"
      :speed="500"
      style="height: 2.8rem"
      :paginationVisible="true"
    >
      <div
        class="nut-swiper-slide"
        v-for="(item,idx) in list"
        :key="idx"
        @click="toGameMsg(item)"
      >
        <img :src="item.image" alt />
      </div>
    </nut-swiper>
  </div>
</template>
<script>
export default {
  name: "swiper",
  props: ["list"],
  components: {},
  data() {
    return {
      dataItem:"",
    };
  },
  mounted() {
  },
  methods: {
    toGameMsg(item) {
      // 跳转类型：0广告位，1公告，2攻略，3外网链接
      if (item.type == 0) {
      this.$router.push({ name: "game", query: { id: item.gameId } });
      } else if (item.type == 1) {
        this.getNoticeDetailFun(item.bulletinId);
      } else if (item.type == 2) {
        this.getStrategyDetailFun(item.strategyId);
      } else if (item.type == 3) {
        window.location.href = item.url;
      }
    },
    getNoticeDetailFun(id) {
      let data = {
        bulletinId: id,
      };
      this.$api.reqData("/api/v1/index/getBulletinInfo", data).then(
        (res) => {
          if (res.code == 200) {
            this.$store.dispatch("GetDetailMsgFun", JSON.stringify(res.data));
            this.$store.dispatch("IsShowDetailFun", true);
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    getStrategyDetailFun(id) {
      let data = {
        strategyId: id,
      };
      this.$api.reqData("/api/v1/index/getStrategyInfo", data).then(
        (res) => {
          if (res.code == 200) {
            this.$store.dispatch("GetDetailMsgFun", JSON.stringify(res.data));
            this.$store.dispatch("IsShowDetailFun", true);
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
  },
};
</script>
<style>
.bannerBox {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/swiper.vue